import PropTypes from 'prop-types';
import { useState } from 'react';
import { connect } from 'react-redux';

import RemoteDoormanCallsListComponent from './RemoteDoormanCallsListComponent';

import { getBuildingsForFilter } from '../Building/actionCreators';
import { getCallCenterAgentsList, getRemoteDoormanCalls } from './actions';

import { getFrequencyStats, getTodayCount } from '../../utils';

import * as buildingSelectors from '../Building/selectors';
import * as commonSelectors from '../Shared/selectors';
import * as selectors from './selectors';

const listKey = 'RemoteDoormanCalls';

const RemoteDoormanCallsListContainer = (props) => {
  const [isChartOpen, setIsChartOpen] = useState(false);

  const { onGetRemoteDoormanCalls, listParams } = props;
  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetRemoteDoormanCalls(queryParams);
  };

  return (
    <RemoteDoormanCallsListComponent
      {...props}
      isChartOpen={isChartOpen}
      setIsChartOpen={setIsChartOpen}
      onExport={onExport}
    />
  );
};

RemoteDoormanCallsListContainer.propTypes = {
  onGetRemoteDoormanCalls: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = (state) => {
  const listParams = commonSelectors.getListParams(state, listKey);
  const items = selectors.getRemoteDoormanCalls(state);
  const agentOptions = selectors.getCallCenterAgentOptions(state, true);
  const buildings = buildingSelectors.getBuildings(state);
  return {
    listKey,
    listParams,
    items,
    agentOptions,
    buildings,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => {
    getBuildingsForFilter(dispatch);
    getCallCenterAgentsList(dispatch, { disable_pagination: true });
  },
  getItems: (queryParams) => {
    getRemoteDoormanCalls(dispatch, queryParams);
    getTodayCount(getRemoteDoormanCalls, dispatch, queryParams);
  },
  onGetRemoteDoormanCalls: (queryParams) =>
    getRemoteDoormanCalls(dispatch, queryParams, true),
  onGetChartData: (queryParams) =>
    getFrequencyStats(getRemoteDoormanCalls, dispatch, queryParams),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RemoteDoormanCallsListContainer);
